import { Box, Stack, Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";

type Props = {
  readonly title: string;
  readonly value: string | React.ReactElement;
};

export const BasicInfoBox: React.FC<Props> = ({ title, value }) => {
  return (
    <Stack spacing={Spacing.XS}>
      <Typography variant="caption" textTransform="uppercase" color="secondary" fontWeight={500} lineHeight={1.4}>
        {title}
      </Typography>
      {typeof value === "string" ? (
        <Typography variant="body2" fontWeight={500} lineHeight={1}>
          {value}
        </Typography>
      ) : (
        <Box>{value}</Box>
      )}
    </Stack>
  );
};
